// Chakra imports
import { Box, Flex, Icon, Image, Text } from "@chakra-ui/react";
import PropTypes from "prop-types";
import React from "react";
import Footer from "components/footer/FooterAuth";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
// Custom components
import { NavLink } from "react-router-dom";
// Assets
import { FaChevronLeft } from "react-icons/fa";

const vdhLogo = `${process.env.PUBLIC_URL}/vdh-logo.svg`;

function AuthIllustration(props) {
  const { children } = props;
  // Chakra color mode
  return (
    <Flex position='relative' h='max-content'>
      <Flex
        h={{
          sm: "initial",
          md: "unset",
          lg: "100vh",
          xl: "97vh",
        }}
        w='100%'
        maxW={{ md: "66%", lg: "1313px" }}
        mx='auto'
        pt={{ sm: "50px", md: "0px" }}
        px={{ lg: "30px", xl: "0px" }}
        ps={{ xl: "70px" }}
        justifyContent='start'
        direction='column'>
        <NavLink
          to='/admin'
          style={() => ({
            width: "fit-content",
            marginTop: "40px",
          })}>
          <Flex
            align='center'
            ps={{ base: "25px", lg: "0px" }}
            pt={{ lg: "0px", xl: "0px" }}
            w='fit-content'>
            <Icon
              as={FaChevronLeft}
              me='12px'
              h='13px'
              w='8px'
              color='secondaryGray.600'
            />
            <Text ms='0px' fontSize='sm' color='secondaryGray.600'>
              Vui Để Học
            </Text>
          </Flex>
        </NavLink>
        {children}
        <Box
          display={{ base: "none", md: "block" }}
          h='100%'
          minH='100vh'
          w={{ lg: "50vw", "2xl": "44vw" }}
          position='absolute'
          right='0px'>
          <Flex
            bgGradient='linear(to-br, #5AC8FA, #7C5CFC 55%, #9B5CFC)'
            justify='center'
            align='center'
            direction='column'
            textAlign='center'
            px='40px'
            w='100%'
            h='100%'
            position='absolute'
            borderBottomLeftRadius={{ lg: "120px", xl: "200px" }}>
            <Image src={vdhLogo} alt='Vui Để Học' w='120px' h='120px' mb='24px'
              borderRadius='28px' boxShadow='0 12px 40px rgba(0,0,0,0.25)' />
            <Text color='white' fontSize='44px' fontWeight='800' letterSpacing='-1px'>
              Vui Để Học
            </Text>
            <Text color='whiteAlpha.900' fontSize='lg' fontWeight='500' mt='10px' maxW='420px'>
              Cùng con chinh phục kho báu tri thức mỗi ngày.
            </Text>
          </Flex>
        </Box>
        <Footer />
      </Flex>
      <FixedPlugin />
    </Flex>
  );
}
// PROPS

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
